import React from 'react';
import { Link } from 'react-router-dom';
import { 
  ArrowRightIcon
} from '@heroicons/react/24/outline';
import Button from './Button';
import Card from './Card';

const getCurrencySymbol = (currency) => {
  switch ((currency || '').toUpperCase()) {
    case 'NGN': return '₦';
    case 'USD': return '$';
    case 'GBP': return '£';
    case 'EUR': return '€';
    default: return '';
  }
};

const CourseCard = ({ 
  course, 
  className = '',
  linkTo = null
}) => {
  const formattedPrice = (course.cost_amount && course.cost_currency)
    ? `${getCurrencySymbol(course.cost_currency)}${Number(course.cost_amount).toLocaleString()}`
    : 'Contact for price';

  const cardContent = (
    <Card 
      className={`group relative overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer border border-gray-200 hover:border-primary-300 ${className}`}
      padding="none"
    >
      {/* Subtle gradient overlay on hover */}
      <div className={`absolute inset-0 bg-gradient-to-br ${course.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
      
      {/* Card Content */}
      <div className="relative p-6">
        {/* Icon and Title Section */}
        <div className="mb-6">
          <div className={`w-16 h-16 bg-gradient-to-br ${course.color} rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform duration-300 mb-4`}>
            <course.icon className="w-8 h-8 text-white" />
          </div>
          
          <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-primary-600 transition-colors leading-tight line-clamp-2">
            {course.title}
          </h3>
        </div>

        {/* Price Section */}
        <div className="mb-6">
          <p className="text-2xl font-bold text-primary-600">
            {formattedPrice}
          </p>
        </div>

        {/* CTA Button */}
        <Link
          to={linkTo || `/course/${course.id || (course.title || course.name || '').toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}`}
          className="block"
        >
          <div className="w-full bg-gray-50 hover:bg-primary-600 text-gray-700 hover:text-white font-medium py-3 px-4 rounded-lg transition-all duration-300 group/btn">
            <span className="flex items-center justify-center text-sm">
              View Details
              <ArrowRightIcon className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
            </span>
          </div>
        </Link>
      </div>
    </Card>
  );

  // If linkTo is provided and we want the entire card to be clickable
  if (linkTo) {
    return (
      <Link to={linkTo} className="block">
        {cardContent}
      </Link>
    );
  }

  return cardContent;
};

export default CourseCard; 